/** ``baseUrl`` must have no trailing slash. */
export function advisorV2ThreadListUrl(baseUrl: string, useCase: string, limit: number, offset: number): string {
  const q = new URLSearchParams({
    use_case: useCase,
    limit: String(limit),
    offset: String(offset),
  });
  return `${baseUrl}/v2/chat/threads?${q.toString()}`;
}

/** Org Kin: list all core lanes (omit ``use_case``). Partner portal must use ``advisorV2ThreadListUrl`` with ``partner``. */
export function advisorV2ThreadListAllCoreUrl(baseUrl: string, limit: number, offset: number): string {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  return `${baseUrl}/v2/chat/threads?${q.toString()}`;
}

export function advisorV2ThreadMessagesUrl(
  baseUrl: string,
  useCase: string,
  threadId: string,
  limit: number,
  offset: number
): string {
  const q = new URLSearchParams({
    use_case: useCase,
    limit: String(limit),
    offset: String(offset),
  });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}/messages?${q.toString()}`;
}

export function advisorV2ThreadDeleteUrl(baseUrl: string, useCase: string, threadId: string): string {
  const q = new URLSearchParams({ use_case: useCase });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}?${q.toString()}`;
}

/**
 * ``GET`` target for the support replies poll. ``useCase`` only picks the surface (``partner`` or
 * org app), so the org app leaves it out.
 */
export function advisorV2SupportRepliesUrl(baseUrl: string, useCase?: string): string {
  const url = `${baseUrl}/v2/chat/support/replies`;
  return useCase ? `${url}?${new URLSearchParams({ use_case: useCase }).toString()}` : url;
}

/** ``POST`` target that marks a thread's support agent replies as seen. */
export function advisorV2SupportSeenUrl(baseUrl: string, useCase: string, threadId: string): string {
  const q = new URLSearchParams({ use_case: useCase });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}/support-seen?${q.toString()}`;
}

/** ``POST`` target for accepting a handoff offer / the persistent control (PS-1353 route). */
export function advisorV2SupportHandoffUrl(baseUrl: string, useCase: string, threadId: string): string {
  const q = new URLSearchParams({ use_case: useCase });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}/support-handoff?${q.toString()}`;
}
